import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  InstallBaseData,
  getBaseTerritory,
  getInstallBases,
} from 'services/basesServices';
import { saveRefuelDataV2 } from 'services/refuelServices';

type RefuelDataRequest = {
  baseName: string;
  currentPercentage: string;
  refuelDate: string;
  isFixedRoute: boolean;
  percentageValidate: boolean;
  dateValidate: boolean;
};

type ResponsibleDataRequest = { [key: string]: string } & {
  name: string;
  phone: string;
  email: string;
  details: string;
};

type RefuelStatusResponse = {
  baseName: string;
  nickname: string;
  status: string;
  message?: string | null;
  caseNumber?: string | null;
  createdDate?: string | null;
};

type NewRefuelContextType = {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  enabledStep: number;
  handleEnabledStep: (step: number) => void;
  handlePercentage: (baseName: string, percentage: string) => void;
  handleRefuelDate: (
    baseName: string,
    date: string,
    isFixedRoute: boolean
  ) => void;
  bases: InstallBaseData[];
  selectedBases: InstallBaseData[];
  selectedBase: InstallBaseData | null;
  responsibleData: ResponsibleDataRequest;
  addSelectedBase: (baseName: string) => void;
  handleSelectedBase: (baseName: string) => void;
  removeSelectedBase: (baseName: string) => void;
  handleResponsible: (value: string, field: string) => void;
  refuelData: RefuelDataRequest[];
  stepError: number;
  statusResponse: RefuelStatusResponse[];
  confirmRefuels: () => Promise<void>;
  addAllSelectedBases: () => void;
  removeAllSelectedBases: () => void;
  finishRefuel: () => void;
  filterTerm: string;
  handleFilterTerm: (term: string) => void;
};

type RefuelProviderProps = {
  children: React.ReactNode;
};

export const NewRefuelContext = createContext<NewRefuelContextType>(
  {} as NewRefuelContextType
);

export const RefuelProvider: React.FC<RefuelProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [enabledStep, setEnabledStep] = useState<number>(1);
  const [refuelData, setRefuelData] = useState<RefuelDataRequest[]>([]);
  const [originalBases, setOriginalBases] = useState<InstallBaseData[]>([]);
  const [bases, setBases] = useState<InstallBaseData[]>([]);
  const [responsibleData, setResponsibleData] =
    useState<ResponsibleDataRequest>({} as ResponsibleDataRequest);
  const [selectedBases, setSelectedBases] = useState<InstallBaseData[]>([]);
  const [selectedBase, setSelectedBase] = useState<InstallBaseData | null>(
    null
  );
  const [stepError, setStepError] = useState<number>(0);
  const [statusResponse, setStatusResponse] = useState<RefuelStatusResponse[]>(
    []
  );
  const [filterTerm, setFilterTerm] = useState('');

  // const basesMockValid = [
  //   {
  //     name: 'BIC053401',
  //     nickname: 'AQUECIMENTO',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-21T16:02:45',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //     baseTerritory: {
  //       name: 'ROTA - PONTA GROSSA - CENTRO (QUA/SEX)',
  //       monday: false,
  //       tuesday: false,
  //       wednesday: true,
  //       thursday: false,
  //       friday: true,
  //       saturday: false,
  //       sunday: false,
  //       base: {
  //         suplayWay: 'Agendado',
  //         suplayDays: 'Quarta-Feira,Sexta-Feira',
  //         suplayFrequency: 'QUA A CADA 4 SEMANA(S)',
  //         numberOfDaysToSuplay: 1,
  //       },
  //       useNewRefuelRule: true,
  //     },
  //   },
  //   {
  //     name: '2006125622.01',
  //     nickname: 'Cosmetico 80/20',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2020-08-04T00:00:00',
  //     creationDate: '2020-08-04T00:00:00',
  //     updateDate: '2024-11-21T16:02:45',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //     baseTerritory: {
  //       name: 'ROTA - MISTURA 80/20 ( SEG A SAB )',
  //       monday: false,
  //       tuesday: false,
  //       wednesday: false,
  //       thursday: false,
  //       friday: false,
  //       saturday: false,
  //       sunday: false,
  //       base: {
  //         suplayWay: 'Pedido',
  //         suplayFrequency: 'PEDIDO',
  //         numberOfDaysToSuplay: 1,
  //       },
  //       useNewRefuelRule: true,
  //     },
  //   },
  //   {
  //     name: 'BIC010693',
  //     nickname: 'INSTALACAO UNICA 80/20',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-21T16:02:45',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //     baseTerritory: {
  //       name: 'ROTA - CARRETA 2 ( SEG A SAB )',
  //       monday: false,
  //       tuesday: false,
  //       wednesday: false,
  //       thursday: false,
  //       friday: false,
  //       saturday: false,
  //       sunday: false,
  //       base: {
  //         suplayWay: 'Pedido',
  //         suplayFrequency: 'PEDIDO',
  //         numberOfDaysToSuplay: 1,
  //       },
  //       useNewRefuelRule: true,
  //     },
  //   },
  //   {
  //     name: 'BIC053709',
  //     nickname: 'MISTURA 50/50',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-21T16:02:45',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //     baseTerritory: {
  //       name: 'ROTA - MISTURA 50/50 ( SEG A SAB )',
  //       monday: false,
  //       tuesday: false,
  //       wednesday: false,
  //       thursday: false,
  //       friday: false,
  //       saturday: false,
  //       sunday: false,
  //       base: {
  //         suplayWay: 'Pedido',
  //         suplayFrequency: 'PEDIDO',
  //         numberOfDaysToSuplay: 1,
  //       },
  //       useNewRefuelRule: true,
  //     },
  //   },
  //   {
  //     name: 'BIC064986',
  //     nickname: 'PIT STOP',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-21T16:02:45',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //     baseTerritory: {
  //       name: 'ROTA - PONTA GROSSA - CENTRO (QUA/SEX)',
  //       monday: false,
  //       tuesday: false,
  //       wednesday: true,
  //       thursday: false,
  //       friday: true,
  //       saturday: false,
  //       sunday: false,
  //       base: {
  //         suplayWay: 'Pedido',
  //         suplayDays: 'Quarta-Feira,Sexta-Feira',
  //         suplayFrequency: 'PEDIDO',
  //         numberOfDaysToSuplay: 1,
  //       },
  //       useNewRefuelRule: true,
  //     },
  //   },
  //   {
  //     name: 'BIC053411',
  //     nickname: 'REFEITORIO',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-21T16:02:45',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //     baseTerritory: {
  //       name: 'ROTA - PONTA GROSSA - CENTRO (QUA/SEX)',
  //       monday: false,
  //       tuesday: false,
  //       wednesday: true,
  //       thursday: false,
  //       friday: true,
  //       saturday: false,
  //       sunday: false,
  //       base: {
  //         suplayWay: 'Agendado',
  //         suplayDays: 'Quarta-Feira,Sexta-Feira',
  //         suplayFrequency: 'QUA A CADA 3 SEMANA(S)',
  //         numberOfDaysToSuplay: 1,
  //       },
  //       useNewRefuelRule: true,
  //     },
  //   },
  // ];

  // const basesMock = [
  //   {
  //     name: 'BIC053401',
  //     nickname: 'AQUECIMENTO',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-06T16:03:08',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //   },
  //   {
  //     name: '2006125622.01',
  //     nickname: 'Cosmetico 80/20',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2020-08-04T00:00:00',
  //     creationDate: '2020-08-04T00:00:00',
  //     updateDate: '2024-11-06T16:03:08',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //   },
  //   {
  //     name: 'BIC010693',
  //     nickname: 'INSTALACAO UNICA 80/20',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-06T16:03:08',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //   },
  //   {
  //     name: 'BIC053709',
  //     nickname: 'MISTURA 50/50',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-06T16:03:08',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //   },
  //   {
  //     name: 'BIC064986',
  //     nickname: 'PIT STOP',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-06T16:03:08',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //   },
  //   {
  //     name: 'BIC053411',
  //     nickname: 'REFEITORIO',
  //     description: 'CL19282-32807',
  //     codeHierarchy: 'INSTALACAO',
  //     quantity: 1,
  //     status: 'A',
  //     activeDateFrom: '2015-09-06T00:00:00',
  //     creationDate: '2015-09-06T00:00:00',
  //     updateDate: '2024-11-06T16:03:08',
  //     address: 'RUA JUMBO',
  //     number: '86',
  //     complement: 'S C',
  //     addressCode: '32807',
  //   },
  // ];

  const handleResponsible = (value: string, field: string): void => {
    const oldResponsible = responsibleData;
    oldResponsible[`${field}`] = value;
    setResponsibleData({ ...oldResponsible });
  };

  const handleFilterTerm = (term: string): void => {
    setFilterTerm(term);
  };

  const validateStepsErrors = (): number => {
    if (enabledStep === 1) {
      const baseErrors = selectedBases.length === 0;
      if (baseErrors) return 1;
    }
    if (enabledStep === 2) {
      const baseErrors = selectedBases.some((base) => !base.percentageValidate);
      if (baseErrors) return 2;
    }
    if (enabledStep === 3) {
      const baseErrors = selectedBases.some((base) => !base.dateValidate);
      if (baseErrors) return 3;
    }
    if (enabledStep === 4) {
      const responsibleErrors = Object.values(responsibleData).length < 4;
      if (responsibleErrors) return 4;
      if (
        !responsibleData?.name ||
        !responsibleData?.phone ||
        !responsibleData?.email ||
        !responsibleData?.details
      ) {
        return 4;
      }
    }
    return 0;
  };

  const handleSelectedBase = (baseName: string): void => {
    const baseToAddIdx = bases.findIndex((base) => base.name === baseName);
    setSelectedBase(baseToAddIdx > -1 ? bases[baseToAddIdx] : null);
  };

  const handleEnabledStep = (step: number): void => {
    const stepErrorsResponse = validateStepsErrors();
    setStepError(stepErrorsResponse);
    if (stepErrorsResponse > 0 && enabledStep < step) return;
    setEnabledStep(step);
    if (step > 1) {
      handleSelectedBase(selectedBases[0].name);
    }
  };

  const getBases = async (): Promise<void> => {
    setIsLoading(true);
    const response = await getInstallBases();

    const responseBases: InstallBaseData[] = await Promise.all(
      response?.map(async (base) => {
        const responseBaseTerritory = await getBaseTerritory(base.name);
        return {
          ...base,
          baseTerritory: responseBaseTerritory,
        };
      }) || ([] as InstallBaseData[])
    );

    setOriginalBases(responseBases);

    setIsLoading(false);
  };

  const addSelectedBase = (baseName: string): void => {
    const baseToAddIdx = bases.findIndex((base) => base.name === baseName);
    const baseToAdd = bases[baseToAddIdx];
    setSelectedBases([...selectedBases, baseToAdd]);
  };

  const removeSelectedBase = (baseName: string): void => {
    const oldBases = selectedBases.filter((base) => base.name !== baseName);
    setSelectedBases([...oldBases]);
  };

  const addAllSelectedBases = (): void => {
    setSelectedBases([...bases]);
  };

  const removeAllSelectedBases = (): void => {
    setSelectedBases([]);
  };

  const handlePercentage = (baseName: string, percentage: string): void => {
    if (!baseName) return;
    const oldRefuelData = refuelData;
    const idxRefuelData = refuelData.findIndex(
      (refuel) => refuel.baseName === baseName
    );
    if (idxRefuelData > -1) {
      oldRefuelData[idxRefuelData].currentPercentage = percentage;
    } else {
      oldRefuelData.push({
        baseName,
        currentPercentage: percentage,
        refuelDate: '',
        isFixedRoute: false,
        percentageValidate: false,
        dateValidate: false,
      });
    }
    const oldSelectedBases = selectedBases;
    const idxSelectedBase = selectedBases.findIndex(
      (selected) => selected.name === baseName
    );
    setRefuelData([...oldRefuelData]);

    oldSelectedBases[idxSelectedBase].percentageValidate = true;
    setSelectedBases([...oldSelectedBases]);
  };

  const handleRefuelDate = (
    baseName: string,
    date: string,
    isFixedRoute: boolean
  ): void => {
    const oldRefuelData = refuelData;
    const idxRefuelData = refuelData.findIndex(
      (refuel) => refuel.baseName === baseName
    );
    if (idxRefuelData > -1) {
      oldRefuelData[idxRefuelData].refuelDate = date;
      oldRefuelData[idxRefuelData].isFixedRoute = isFixedRoute;
      oldRefuelData[idxRefuelData].dateValidate = true;
    }
    const oldSelectedBases = selectedBases;
    const idxSelectedBase = selectedBases.findIndex(
      (selected) => selected.name === baseName
    );

    setRefuelData([...oldRefuelData]);
    oldSelectedBases[idxSelectedBase].dateValidate = true;
    setSelectedBases([...oldSelectedBases]);
  };

  const saveRefuel = async (baseName: string): Promise<void> => {
    const idxRefuelData = refuelData.findIndex(
      (refuel) => refuel.baseName === baseName
    );
    if (idxRefuelData > -1) {
      const refuelDataRequest = refuelData[idxRefuelData];
      const response = await saveRefuelDataV2({
        currentGasPercentage: refuelDataRequest.currentPercentage,
        isFixRoute: refuelDataRequest.isFixedRoute,
        refuelDate: refuelDataRequest.refuelDate,
        installBase: refuelDataRequest.baseName,
        name: responsibleData.name,
        phone: responsibleData.phone,
        email: responsibleData.email,
        detail: responsibleData.details,
      });

      const { caseNumber, dataMessage, createdDate, isError } = response;

      let statusReturn = 'loading';
      if (isError) {
        statusReturn = 'error';
      } else if (caseNumber && dataMessage) {
        statusReturn = 'warning';
      }
      if (caseNumber && dataMessage === '') {
        statusReturn = 'success';
      }

      const oldRefuelStatus = statusResponse;
      const idxRefuelStatus = oldRefuelStatus.findIndex(
        (status) => status.baseName === baseName
      );

      if (idxRefuelStatus > -1) {
        oldRefuelStatus[idxRefuelStatus].status = statusReturn;
        oldRefuelStatus[idxRefuelStatus].caseNumber = caseNumber;
        oldRefuelStatus[idxRefuelStatus].message = dataMessage;
        oldRefuelStatus[idxRefuelStatus].createdDate = createdDate;
        setStatusResponse([...oldRefuelStatus]);
      }
    }
  };

  const confirmRefuels = async (): Promise<void> => {
    const stepErrorsResponse = validateStepsErrors();
    if (stepErrorsResponse > 0 && enabledStep === 4) return;
    setIsLoading(true);
    await Promise.all(selectedBases.map((base) => saveRefuel(base.name)));
    setIsLoading(false);
  };

  const finishRefuel = (): void => {
    setEnabledStep(1);
    setRefuelData([]);
    setResponsibleData({} as ResponsibleDataRequest);
    setSelectedBases([]);
    setSelectedBase(null);
    setStepError(0);
    setStatusResponse([]);
    setFilterTerm('');
    getBases();
  };

  useEffect(() => {
    const newBases: RefuelStatusResponse[] = [];
    selectedBases.forEach((base) =>
      newBases.push({
        baseName: base.name,
        nickname: base.nickname,
        status: 'loading',
      })
    );
    if (newBases.length > 0) setStatusResponse([...newBases]);
  }, [selectedBases]);

  useEffect(() => {
    getBases();
  }, []);

  useEffect(() => {
    if (filterTerm) {
      const filteredBases = originalBases.filter((base) =>
        base.nickname.toLowerCase().includes(filterTerm.toLowerCase())
      );
      setBases(filteredBases);
    } else {
      setBases(originalBases);
    }
  }, [filterTerm, originalBases]);

  return (
    <NewRefuelContext.Provider
      value={{
        isLoading,
        enabledStep,
        handleEnabledStep,
        bases,
        selectedBases,
        addSelectedBase,
        removeSelectedBase,
        selectedBase,
        handleSelectedBase,
        handlePercentage,
        handleRefuelDate,
        refuelData,
        handleResponsible,
        responsibleData,
        stepError,
        statusResponse,
        confirmRefuels,
        addAllSelectedBases,
        removeAllSelectedBases,
        filterTerm,
        handleFilterTerm,
        finishRefuel,
        setIsLoading,
      }}
    >
      {children}
    </NewRefuelContext.Provider>
  );
};

export function useNewRefuel(): NewRefuelContextType {
  const context = useContext(NewRefuelContext) as NewRefuelContextType;
  return context;
}
